module.exports = __webpack_public_path__ + "img/index_list_item_icon_9.7422a7fa.svg";